export const UPDATE_JWT_TOKEN = "UPDATE_JWT_TOKEN";
export const UPDATE_USER_ACCOUNT = "UPDATE_USER_ACCOUNT";
export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const AUTHORIZE_USER = "AUTHORIZE_USER";
